import React, { useState } from 'react';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { Button } from '@uhg-abyss/web/ui/Button';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { TextInputArea } from '@uhg-abyss/web/ui/TextInputArea';
import { FindhelpProgram } from '@src/api.types';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { EmailBody } from './EmailBody';
import { API } from '@src/api';
import { EmailBodyUniteUs } from './EmailBodyUniteUs';
import { UniteUsProgram } from '../../../../../packages/ui/src';
export type EmailMemberProps = {
  isOpen: boolean;
  setIsOpen: (nextValue: boolean) => void;
  programData: FindhelpProgram | UniteUsProgram;
  vendor: 'findhelp' | 'uniteus';
};

export const EmailMember = ({
  isOpen,
  setIsOpen,
  programData,
  vendor,
}: EmailMemberProps) => {
  const [emailAddress, setEmailAddress] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [notes, setNotes] = useState('');
  const updateEmailBody = (t) => {
    setEmailBody(t);
  };

  const form = useForm({
    defaultValues: {
      email: emailAddress,
      notes: '',
    },
  });

  const checkButtonDisabled = () => {
    return !form.formState.isValid;
  };
  const handleNotes = (e) => {
    setNotes(e.target.value);
  };

  const handleEmailAddress = (e) => {
    setEmailAddress(e.target.value);
    form.trigger('email');
  };

  // TODO: save for next story when backend is ready
  const sendEmail = async () => {
    const resp = await API.postSendEmail(emailAddress, emailBody, notes);

    if (!resp || resp.status !== 200) {
      // TODO - Show an error modal
      console.error('Could not send email');
      return;
    }

    // TODO - Show success modal
  };

  return (
    <React.Fragment>
      <ModalDialog
        header="Email Member"
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      >
        <div>
          <FormProvider state={form}>
            <Layout.Group grow>
              <TextInput
                label="Email Address"
                model="email"
                onChange={handleEmailAddress}
                validators={{
                  required: 'Enter a valid email address',
                  pattern: {
                    value:
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    message: 'Invalid Email',
                  },
                }}
              />
            </Layout.Group>
            {/* <div style={{ paddingTop: '10px' }}>
              <TextInputArea
                label="Additional Notes"
                model="notes"
                onChange={handleNotes}
                validators={{ required: false }}
              />
            </div> */}
          </FormProvider>
          {vendor === 'findhelp' ? (
            <EmailBody
              program={programData as FindhelpProgram}
              updateEmailBody={updateEmailBody}
            />
          ) : (
            <EmailBodyUniteUs
              program={programData as UniteUsProgram}
              updateEmailBody={updateEmailBody}
            />
          )}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '12px' }}>
          <Button
            data-cy="send-email-button"
            onClick={() => {
              setIsOpen(false);
              sendEmail();
            }}
            isDisabled={checkButtonDisabled()}
          >
            Send
          </Button>
        </div>
      </ModalDialog>
    </React.Fragment>
  );
};
